import { ArrowPathIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'
import { generatePassword } from 'utils'

// Visible password (the system admin shares it with the user) with a regenerate button
const PasswordField = ({ value, onChange, isMissing = false }) => {
  const { t } = useTranslation()
  return (
    <div>
      <label htmlFor='password' className='block text-sm font-medium text-gray-700'>
        {t('system.tenants.form.password')} *
      </label>
      <div className='flex items-center mt-1'>
        <input
          id='password'
          type='text'
          name='password'
          value={value || ''}
          onChange={onChange}
          minLength={8}
          className={`w-full p-2 border rounded-md shadow-sm ${isMissing ? 'border-orange-500' : ''}`}
        />
        <button
          type='button'
          title={t('system.tenants.form.generatePassword')}
          className='ml-2 px-3 py-2 bg-gray-100 text-gray-800 rounded-lg hover:bg-gray-200'
          onClick={() => onChange({ target: { name: 'password', value: generatePassword(12) } })}
        >
          <ArrowPathIcon className='w-5 h-5 text-gray-500' />
        </button>
      </div>
      <p className='mt-1 text-xs text-gray-500'>{t('system.tenants.form.passwordHint')}</p>
    </div>
  )
}

export default PasswordField
